// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"SocialIcon_socialIcon__SQQQw","icon":"SocialIcon_icon__uEpXM"};